export const FILTER_STATUS_ALL = 'All';
export const FILTER_STATUS_PENDING = 'Pending';
export const FILTER_STATUS_CLOSED = 'Closed';
export const FILTER_STATUS_IN_SHIPPING = 'InShipping';
export const FILTER_STATUS_SHIPPED = 'Shipped';
export const FILTER_STATUS_NEW = 'New';

export const statusColors = (status) => {
    switch (status.toLowerCase()) {
        case FILTER_STATUS_PENDING.toLowerCase():
            return 'gray';
        case FILTER_STATUS_CLOSED.toLowerCase():
            return 'black';
        case FILTER_STATUS_IN_SHIPPING.toLowerCase():
            return 'orange';
        case FILTER_STATUS_SHIPPED.toLowerCase():
            return 'green';
        default :
            return 'white'
    }
}

export const DELIVERY_TYPE_WALK_IN = 'Wallk in';

export const FILTER_INITIAL_STATE = {
    status: FILTER_STATUS_PENDING,
    date: {start: null, end: null},
    user: null,
    delivery: {vendor: null, location: null}
};
